/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { AddUserOrGroupModule } from '../add-user-or-group/add-user-or-group.module';
import { ModifyClientCifsShareModule } from '../modify-client-cifs-share/modify-client-cifs-share.module';
import { RemoveClientCifsShareModule } from '../remove-client-cifs-share/remove-client-cifs-share.module';
import { FrontTableClientCifsShareComponent } from './front-table-client-cifs-share.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        RemoveClientCifsShareModule,
        ModifyClientCifsShareModule,
        AddUserOrGroupModule,
    ],
    declarations: [FrontTableClientCifsShareComponent],
    exports: [FrontTableClientCifsShareComponent],
})
export class FrontTableClientCifsShareModule { }

